export function calculatePercentage (total:number=0, given:number=0) {
    if (total === 0) return 0
    const percentage = (given/total)*100
    // return parseFloat(percentage?.toFixed(2))
    return Math.ceil(percentage || 0) || 0
}